import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PlayerList from './components/players/PlayerList';
import { PrivateRoute } from './routes/PrivateRoute';
import TournamentListPage from './features/tournament/pages/TournamentListPage';
import ClubListPage from './components/clubs/ClubListPage';
import { NotFound } from '@iziping/ui';
import { AskPasswordPage, ResetPasswordPage } from '@iziping/ui';
import LogoImage from './assets/iziping_logo_750px.png';
import HeatPage from './components/heat/HeatPage';
import ClubPage from './components/clubs/ClubPage';
import HeatManagement from './components/heat/HeatManagement';
import SearchPlayers from './components/players/SearchPlayers';
import PlayerTournamentDetail from './features/tournament/pages/PlayerTournamentDetail';
import MatchesManagement from './components/matches/MatchesManagement';
import FinishedMatchesManagement from './components/matches/FinishedMatchesManagement';
import BracketVisualizationPage from './components/bracket/BracketVisualizationPage';
import TournamentResults from './features/statistics/pages/TournamentResults';
import TournamentStatistics from './features/statistics/pages/TournamentStatistics';
import TableStatistics from './features/statistics/pages/TableStatistics';
import RegistrationPage from './components/public/RegistrationPage';
import ConfirmationRegistrationPage from './components/public/ConfirmationRegistrationPage';
import SurveyPage from './components/public/SurveyPage';
import PlayerPage from './components/players/PlayerPage';
import TournamentPage from './features/tournament/pages/TournamentPage';
import TournamentDetail from './features/tournament/pages/TournamentDetail';
import TournamentViewPage from './features/tournament/pages/TournamentViewPage';
import TournamentViewPlayerPage from './features/tournament/pages/TournamentViewPlayerPage';
import { LoginPage } from '@iziping/ui';
import { getConfig } from './config/appConfig';
import PreRegistrationListPage from './features/tournament/pages/PreRegistrationListPage';
import UserSettingsPage from './features/user/UserSettingsPage';

const App = () => {
    return (
        <Router>
            <Routes>
                {/* ── Authentification ─────────────────────────── */}
                <Route
                    path="/login"
                    element={<LoginPage logo={LogoImage} googleClientId={getConfig().googleClientId} />}
                />
                <Route path="/ask-password" element={<AskPasswordPage logo={LogoImage} />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage logo={LogoImage} />} />

                {/* ── Public ───────────────────────────────────── */}
                <Route path="/tournament/:id/view" element={<TournamentViewPage />} />
                <Route path="/tournament/:id/view/:playerId" element={<TournamentViewPlayerPage />} />
                <Route path="/registration/:uuid" element={<RegistrationPage />} />
                <Route path="/registration/:uuid/edit/:registrationId" element={<RegistrationPage />} />
                <Route path="/registration-confirmation/:uuid" element={<ConfirmationRegistrationPage />} />
                <Route path="/survey/:token" element={<SurveyPage />} />

                {/* ── Privé ────────────────────────────────────── */}
                <Route element={<PrivateRoute />}>
                    {/* Tournois */}
                    <Route path="/" element={<TournamentListPage />} />
                    <Route path="/tournaments/new" element={<TournamentPage />} />
                    <Route path="/tournaments/:id/:tab?" element={<TournamentDetail />} />
                    <Route path="/tournaments/:id/players/:playerId" element={<PlayerTournamentDetail />} />
                    <Route path="/pre-registrations" element={<PreRegistrationListPage />} />

                    {/* Users */}
                    <Route path="/settings" element={<UserSettingsPage />} />

                    {/* Joueurs */}
                    <Route path="/players" element={<PlayerList />} />
                    <Route path="/players/new" element={<PlayerPage />} />
                    <Route path="/players/search" element={<SearchPlayers />} />
                    <Route path="/players/:id" element={<PlayerPage />} />

                    {/* Clubs */}
                    <Route path="/clubs" element={<ClubListPage />} />
                    <Route path="/clubs/new" element={<ClubPage />} />
                    <Route path="/clubs/:id" element={<ClubPage />} />

                    {/* Poules */}
                    <Route path="/heats/new" element={<HeatPage />} />
                    <Route path="/heats/:id" element={<HeatPage />} />
                    <Route path="/heats/management/:id" element={<HeatManagement />} />

                    {/* Matchs */}
                    <Route path="/matches/manage" element={<MatchesManagement />} />
                    <Route path="/matches/bracket" element={<BracketVisualizationPage />} />
                    <Route path="/matches/finished" element={<FinishedMatchesManagement />} />

                    {/* Statistiques */}
                    <Route path="/statistics/results" element={<TournamentResults />} />
                    <Route path="/statistics/detail" element={<TournamentStatistics />} />
                    <Route path="/statistics/tables" element={<TableStatistics />} />
                </Route>

                {/* ── Fallback ─────────────────────────────────── */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default App;
